import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useAppDispatch, useAppState } from 'Context/AppContext/AppContext'
import {
  UPDATE_FUNDER_ORG_CONFIG,
  UPDATE_FUNDER_ORG_CONFIG_ERRORED,
  UPDATE_FUNDER_ORG_CONFIG_LOADING,
} from 'TypeDefs/AppContext'
import { useQuery } from '@apollo/client'
import GET_FUNDER_ORG_CONFIG_QUERY from 'Apollo/Queries/GetFunderOrgConfig'
import { ReturnedFunderOrg } from 'TypeDefs/FunderOrgConfig'

const useFunderOrgConfig = () => {
  const {
    userConfig: { email },
  } = useAppState()
  const dispatch = useAppDispatch()

  const { data, loading } = useQuery<ReturnedFunderOrg>(
    GET_FUNDER_ORG_CONFIG_QUERY,
    {
      variables: {
        email,
      },
      context: { clientName: 'batched' },
      skip: !email,
      onError: () => {
        dispatch({
          type: UPDATE_FUNDER_ORG_CONFIG_ERRORED,
          errored: true,
        })
      },
    }
  )

  useEffect(() => {
    if (data && !loading && data.funderOrgConfig.orgId) {
      dispatch({
        type: UPDATE_FUNDER_ORG_CONFIG,
        // TODO: Update name to funderOrgConfig.  Use strong types from generated-types file
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        funderOrgConfig: data.funderOrgConfig,
      })
    }
  }, [data, loading, dispatch])

  useEffect(() => {
    dispatch({
      type: UPDATE_FUNDER_ORG_CONFIG_LOADING,
      loading,
    })
  }, [loading, dispatch])
}

export default useFunderOrgConfig
